import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { SizeWindow } from '../../../shared/enums/size-window';

export interface DialogDataPopup {
  size: { outerWidth: number, innerHeight: number, sizeWindow: SizeWindow, sizeWindowNumber: number, sizeWindowText: string};
  namePopup: string;
  title: string;
  backgroundColorContent: string;
  data: any;
}

@Component({
  selector: 'app-popup-deconnected-user',
  templateUrl: './popup-deconnected-user.component.html',
  styleUrls: ['./popup-deconnected-user.component.scss']
})
export class PopupDeconnectedUserComponent implements OnInit {

  private ngUnsubscribe = new Subject();

  constructor(public dialogRef: MatDialogRef<PopupDeconnectedUserComponent>, @Inject(MAT_DIALOG_DATA) public dataReceived: DialogDataPopup) { }

  ngOnInit(): void {
    console.log(this.dataReceived)
  }

  onClosePopup() {
    this.dialogRef.close({ annulation: true, validation : true })
  }
  // { title: "Vous avez été déconnecté", data: { Nom_Commercial: "Nom_Commercial", Siege_Email: "Siege_Email", Siege_Telephone: "Siege_Telephone"  } }
}
